import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/services/auth/auth.service';
import { fadeInOut } from '../shared/services/common/animations';

@Component({
  selector: 'account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css'],
  animations: [fadeInOut]
})
export class AccountComponent implements OnInit {
  isProfileActived = true;
  isPreferencesActived = false;
  isUsersActived = false;
  isRolesActived = false;
  displayProfile = false;

  fragmentSubscription: any;
  languageChangedSubscription: any;
  rolesChangedSubscription: any;

  readonly profileTab = 'profile';
  readonly preferencesTab = 'preferences';
  readonly usersTab = 'users';
  readonly rolesTab = 'roles';

  activeTab: string | undefined = this.profileTab;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
  }

  onShowTab(event: any) {
    this.setActiveTab(event.target.hash);
    switch (this.activeTab) {
      case this.profileTab:
        this.isProfileActived = true;
        break;
      case this.preferencesTab:
        this.isPreferencesActived = true;
        break;
      case this.usersTab:
        this.isUsersActived = true;
        break;
      case this.rolesTab:
        this.isRolesActived = true;
        break;
      default:
        throw new Error('Selected bootstrap tab is unknown. Selected Tab: ' + this.activeTab);
    }
  }

  setActiveTab(tab: string) {
    this.activeTab = tab.split('#', 2).pop();
  }
}
